// @vendor
const { APIPost } = require('utilities/APIRequestHelper');

// @constants
const actionTypes = require('constants/actionTypes');

const resetCardTravel = () => ({
    type: actionTypes.CARD_TRAVEL_ON_RESET,
})


const switchCardTravelOn = () => { };

const switchCardTravelOff = () => { };



const setCardTravelPlusFailure = cardId => ({
    type: actionTypes.SET_CARD_TRAVEL_PLUS_ON_FAILURE,
    payload: {
        cardId,
    }
});

const setCardTravelPlusRequest = cardId => ({
    type: actionTypes.SET_CARD_TRAVEL_PLUS_ON_REQUEST,
    payload: {
        cardId,
    }
});

const setCardTravelPlusSuccess = (contractNumbers, cardId) => ({
    type: actionTypes.SET_CARD_TRAVEL_PLUS_ON_SUCCESS,
    payload: {
        contractNumbers,
        cardId,
    }
});

const setCardTravelPlus = cardId => (dispatch, getState) => {
    const immCards = getState().cards;
    let cardsR42List;

    if (!!cardId) {
        const immCard = immCards.getIn(['byId', cardId]);
        cardsR42List = [{
            numeroContrato: immCard.getIn(['contract', 'number']),
            productType: immCard.getIn(['contract', 'product']),
            productSubType: immCard.getIn(['product', 'subtype']),
            productStandard: immCard.getIn(['product', 'standard']),
        }];
    } else {
        cardsR42List = [];
        immCards.get('cardNumbersTravelPlus').forEach(immCardTravelPlus => {
            cardsR42List.push({
                numeroContrato: immCardTravelPlus.get('contractNumber'),
                productType: immCardTravelPlus.get('productType'),
                productSubType: immCardTravelPlus.get('subtype'),
                productStandard: immCardTravelPlus.get('standard'),
            });
        });
    }

    if (cardsR42List.length > 0) {
        const requestData = {
            header: {
                version: 2,
            },
            query: {
                numerosContratos: cardsR42List,
            }
        };

        dispatch(setCardTravelPlusRequest(cardId));
        return APIPost({
            dispatch,
            endpoint: 'travelPlusGetContracts',
            params: requestData,
        })
            .then(response => {
                dispatch(setCardTravelPlusSuccess(response, cardId))
            })
            .catch(response => {
                dispatch(setCardTravelPlusFailure(cardId));
                if (!response.error) {
                    throw response;
                }
            });
    }
}
module.exports = {
    switchCardTravelOn,
    switchCardTravelOff,
    resetCardTravel,
    setCardTravelPlus
};
